﻿namespace Illy.SafeStack

type ListOption =
    {
        Id: int
        Value: string
        Group: string
    }

[<RequireQualifiedAccess>]
type ListOptionType<'a> = 
    | Standard of ListOption
    | WithSingleFlag of ListOption * bool
    | WithManyFlags of ListOption * 'a

type NoFlags = NoFlags
type SingleFlag = SingleFlag

[<RequireQualifiedAccess>]
type ListType<'a> = 
    | Standard of ListOption list
    | WithSingleFlag of (ListOption * bool) list
    | WithManyFlags of (ListOption * 'a) list

[<RequireQualifiedAccess>]
module ListOption = 
    let getValue (opt: ListOption) = opt.Value

    let getId (opt: ListOption) = opt.Id

    let getListItemById id =
        function
        | ListType.Standard list -> 
            list |> List.find (fun x -> x.Id = id)  |> ListOptionType.Standard
        | ListType.WithSingleFlag list -> 
            list |> List.find (fun (li,_) -> li.Id = id)  |> ListOptionType.WithSingleFlag
        | ListType.WithManyFlags list -> 
            list |> List.find (fun (li,_) -> li.Id = id)  |> ListOptionType.WithManyFlags

    let convertToList = 
        function 
        | ListType.Standard list -> list
        | ListType.WithSingleFlag list -> List.map fst list
        | ListType.WithManyFlags list -> List.map fst list

[<RequireQualifiedAccess>]
module ListOptionType =

    let getListOption =
        function
        | ListOptionType.Standard opt
        | ListOptionType.WithSingleFlag (opt,_)
        | ListOptionType.WithManyFlags (opt,_) -> opt

    let getId lOption = lOption |> (getListOption >> ListOption.getId)
    let getListValue lOption = lOption |> (getListOption >> ListOption.getValue)
        
    let unpackStandard =
        function 
        | ListOptionType.Standard x -> x
        | _ -> failwith "cannot unpack other types"

    let unpackWithSingleFlag =
        function 
        | ListOptionType.WithSingleFlag (x,y) -> (x,y) 
        | _ -> failwith "cannot unpack other types"

    let unpackWithManyFlags =
        function 
        | ListOptionType.WithManyFlags (x,y) -> (x,y) 
        | _ -> failwith "cannot unpack other types"